import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getTableCells, methodResult, responseType } from '../../../utils/TableCells';
import { actions } from '../../modules/Actions';
import { getReportTableRowKeys } from '../ReportTableRowReducer';
import { addRowTotal, columnDisps, columnKeys, rowData, TableDataProps } from '../../../utils/NegotiationReducerUtils';
import _isEqual from 'lodash/isEqual';
import { periodViewColumns } from '../../../Common';

export const periodInitialState: TableDataProps = {
  // Stateの初期値
  header: columnKeys(periodViewColumns),
  headerDisp: columnDisps(periodViewColumns),
  data: rowData(),
};

function makingTableData(dtoToViewTable: methodResult) {
  return {
    header: periodInitialState.header,
    headerDisp: periodInitialState.headerDisp,
    data: addRowTotal(dtoToViewTable),
  };
}

export const NegotiationPeriodReducer = reducerWithInitialState(periodInitialState).case(
  actions.updateNegotiation.period,
  (state: TableDataProps, payload: responseType) => {
    const rowKeys = getReportTableRowKeys();
    const viewRowWithoutTotal = rowKeys.slice(1);
    const tableCells = getTableCells(payload, columnKeys(periodViewColumns), viewRowWithoutTotal);
    const newState = makingTableData(tableCells);

    return _isEqual(state.data, newState.data) ? state : newState;
  }
);
